<template>
  <div class="section">
    <div class="inquiry-wrap">
      <div class="section-tit">1:1 문의하기</div>

      <div v-if="product !== null" class="inquiry-product">
        <img class="product-image" :src="product.main_image_url[0]" alt="상품 이미지" />
        <div class="product-details">
          <div class="product-title">[{{ product.brand }}] {{ product.product_name }}</div>
          <div class="product-price">
            <!-- 정가
            <span class="font-strike">{{ _formatAmount(product.cost_price) }}원</span
            >&nbsp;&nbsp;|&nbsp;&nbsp; -->
            구매가
            <span class="font-blue">{{ _formatAmount(sellingPrice) }}원</span>
          </div>
        </div>
      </div>

      <!-- 문의내용 -->
      <div class="inquiry-info">
        <label class="form-label">문의제목<span class="font-red">*</span></label>
        <input v-model="inquiry.title" type="text" class="input-form" />
      </div>
      <div class="inquiry-info">
        <label class="form-label">문의내용 <span class="font-red">*</span></label>
        <textarea
          v-model="inquiry.content"
          maxlength="500"
          placeholder="문의 내용을 입력하세요"
          class="input-form"
          rows="5"
        ></textarea>
        <div class="char-count">{{ inquiry?.content?.length }}/500</div>
      </div>

      <!-- 사진첨부 -->
      <div class="inquiry-info">
        <div class="form-label">사진첨부 ({{ images?.length }}/3)</div>
        <div class="image-upload-list">
          <div v-for="(img, idx) in images" :key="idx" class="image-thumb">
            <img :src="img.url" alt="첨부 이미지" />
            <button class="remove-btn" @click="removeImage(idx)">×</button>
          </div>
          <label v-if="images.length < 3" class="upload-box">
            <input type="file" accept="image/*" style="display: none" @change="onFileChange" />
            <div class="upload-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M22.5 18C22.5 18.3978 22.342 18.7794 22.0607 19.0607C21.7794 19.342 21.3978 19.5 21 19.5H3C2.60218 19.5 2.22064 19.342 1.93934 19.0607C1.65804 18.7794 1.5 18.3978 1.5 18V9C1.5 8.60218 1.65804 8.22064 1.93934 7.93934C2.22064 7.65804 2.60218 7.5 3 7.5H4.758C5.95086 7.49935 7.09465 7.0251 7.938 6.1815L9.183 4.9395C9.4635 4.65891 9.84375 4.50088 10.2405 4.5H13.7565C14.1543 4.50008 14.5358 4.65818 14.817 4.9395L16.059 6.1815C16.4769 6.59957 16.9732 6.9312 17.5193 7.15743C18.0655 7.38366 18.6508 7.50007 19.242 7.5H21C21.3978 7.5 21.7794 7.65804 22.0607 7.93934C22.342 8.22064 22.5 8.60218 22.5 9V18ZM3 6C2.20435 6 1.44129 6.31607 0.87868 6.87868C0.316071 7.44129 0 8.20435 0 9L0 18C0 18.7956 0.316071 19.5587 0.87868 20.1213C1.44129 20.6839 2.20435 21 3 21H21C21.7956 21 22.5587 20.6839 23.1213 20.1213C23.6839 19.5587 24 18.7956 24 18V9C24 8.20435 23.6839 7.44129 23.1213 6.87868C22.5587 6.31607 21.7956 6 21 6H19.242C18.4464 5.99983 17.6835 5.68365 17.121 5.121L15.879 3.879C15.3165 3.31635 14.5536 3.00017 13.758 3H10.242C9.44642 3.00017 8.68348 3.31635 8.121 3.879L6.879 5.121C6.31652 5.68365 5.55358 5.99983 4.758 6H3Z"
                  fill="#999999"
                />
                <path
                  d="M12 16.5C11.0054 16.5 10.0516 16.1049 9.34835 15.4017C8.64509 14.6984 8.25 13.7446 8.25 12.75C8.25 11.7554 8.64509 10.8016 9.34835 10.0983C10.0516 9.39509 11.0054 9 12 9C12.9946 9 13.9484 9.39509 14.6517 10.0983C15.3549 10.8016 15.75 11.7554 15.75 12.75C15.75 13.7446 15.3549 14.6984 14.6517 15.4017C13.9484 16.1049 12.9946 16.5 12 16.5ZM12 18C13.3924 18 14.7277 17.4469 15.7123 16.4623C16.6969 15.4777 17.25 14.1424 17.25 12.75C17.25 11.3576 16.6969 10.0223 15.7123 9.03769C14.7277 8.05312 13.3924 7.5 12 7.5C10.6076 7.5 9.27226 8.05312 8.28769 9.03769C7.30312 10.0223 6.75 11.3576 6.75 12.75C6.75 14.1424 7.30312 15.4777 8.28769 16.4623C9.27226 17.4469 10.6076 18 12 18ZM4.5 9.75C4.5 9.94891 4.42098 10.1397 4.28033 10.2803C4.13968 10.421 3.94891 10.5 3.75 10.5C3.55109 10.5 3.36032 10.421 3.21967 10.2803C3.07902 10.1397 3 9.94891 3 9.75C3 9.55109 3.07902 9.36032 3.21967 9.21967C3.36032 9.07902 3.55109 9 3.75 9C3.94891 9 4.13968 9.07902 4.28033 9.21967C4.42098 9.36032 4.5 9.55109 4.5 9.75Z"
                  fill="#999999"
                />
              </svg>
              <div>업로드</div>
            </div>
          </label>
        </div>
      </div>

      <div class="btn-wrap">
        <button to="/" class="btn btn-lg btn-full btn-primary" @click="setInquiry()">
          {{ idx ? '수정하기' : '문의하기' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount, watch } from 'vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import {
  _formatAmount,
  _setStorageWithExpiry,
  _getStorageWithExpiry,
  _safeAtob,
} from '../utils/common.js';
import api from '@/utils/api.js';

const router = useRouter();
const request = JSON.parse(history.state?.request || '{}');
const idx = history.state?.idx || '';
console.log(idx);
const goodsCode = ref(null);
const product = ref(null);
const idntCode = _safeAtob(_getStorageWithExpiry('id'));
const images = ref([]);
const inquiry = reactive({
  title: '',
  content: '',
});
const sellingPrice = ref(0);

watch(goodsCode, newVal => {
  if (newVal) {
    postData();
  }
});

onMounted(async () => {
  if (Object.keys(request).length != 0) {
    const urls = [request.img_url_1, request.img_url_2, request.img_url_3].filter(Boolean);

    try {
      const results = await Promise.allSettled(urls.map(url => urlToBase64(url)));
      const base64List = results
        .filter(r => r.status === 'fulfilled')
        .map(r => r.value)
        .filter(Boolean);

      images.value = base64List.map(base64 => ({ url: base64 }));

      const failed = results.filter(r => r.status === 'rejected');

      if (failed.length) {
        console.warn('[InquiryPage] 일부 이미지 base64 변환 실패:', failed);
      }
    } catch (e) {
      console.warn('[InquiryPage] 이미지 base64 변환 중 오류:', e);
      images.value = [];
    }
    inquiry.title = request.title;
    inquiry.content = request.inquiry_contents;
  }

  if (history.state?.goodsCode) {
    goodsCode.value = history.state?.goodsCode;
  }
});

// function handleMessage(event) {
//   // id-idnt_code / idx-주문번호 / code-상품코드
//   //{"type":"sendInquiry","id":"nid_40619948","idx":"1590","code":"836180"}
//   const { type, id, code, seller_yn, market_order_id } = event.data;
//   if (type === 'sendInquiry') {
//     _setStorageWithExpiry('id', id);
//     _setStorageWithExpiry('sy', btoa(seller_yn));
//     idntCode.value = id;
//     goodsCode.value = code;
//     request.market_order_id = market_order_id || '';
//   }
// }

async function postData() {
  try {
    const response = await api.post('/goods.php', {
      mode: 'marketDetail',
      goods_code: goodsCode.value,
      idnt_code: idntCode,
    });

    const response2 = await api.post('/tble.php', {
      mode: 'orderPrice',
      market_order_id: request.order_id,
      goods_code: goodsCode.value,
      idnt_code: idntCode,
    });

    sellingPrice.value = response2.data.data.selling_price || 0;

    console.log(sellingPrice.value);

    if (response.data) {
      product.value = response.data.data;
    } else {
      console.error('API 응답에 결과가 없습니다.');
    }
  } catch (error) {
    alert('에러 발생:', error);
  }
}

async function setInquiry() {
  const param = {
    mode: 'requestInsert',
    title: inquiry.title,
    type: 99,
    idx: idx || '',
    inquiry_contents: inquiry.content,
    img_url_1: images.value[0]?.url || '',
    img_url_2: images.value[1]?.url || '',
    img_url_3: images.value[2]?.url || '',
    delivery_item_order_id: '',
    market_order_id: request.order_id || '',
    goods_code: goodsCode.value,
    idnt_code: idntCode,
  };

  console.log('전송할 파라미터:', param);

  const response = await api.post('/order.php', param);

  console.log('응답:', response.data);
  if (response.data.result == 'SUCCESS') {
    alert('문의가 등록되었습니다.');
    router.push('/inquiryList');
  } else {
    alert('문의 접수에 실패했습니다. 다시 시도해주세요.');
  }
}

function onFileChange(e) {
  const files = e.target.files;
  if (!files.length) return;
  if (images.value.length >= 3) return;

  const file = files[0];
  const reader = new FileReader();

  reader.onload = event => {
    images.value.push({ url: event.target.result });
  };

  reader.readAsDataURL(file);
  e.target.value = '';
}

function removeImage(idx) {
  images.value.splice(idx, 1);
}

async function urlToBase64(url) {
  if (url.startsWith('data:image')) return url;

  const response = await fetch(url);
  const blob = await response.blob();

  // 이미지가 아닌 경우 방지
  if (!blob.type.startsWith('image/')) {
    console.log(`Not an image: ${blob.type}`);
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
</script>
